var exports = {
  "i": "wrapper__6YIQxU",
  "j": "connectedDot__HT0C3V",
};

module.exports = exports;
